import React from 'react';
import FloatingLines from './FloatingLines';

const CommissionValue = () => {
  const values = [
    {
      icon: 'fa-bullseye',
      title: 'You Bring Qualified Leads',
      description: 'No tire-kickers. No browsers. Just serious brands ready to fix their ad strategy.'
    },
    {
      icon: 'fa-dollar-sign',
      title: 'Better Than Sales Reps',
      description: 'We\'d pay $3,000-8,000 for a sales rep to close these deals. Your commission is our customer acquisition cost.'
    },
    {
      icon: 'fa-handshake',
      title: 'Long-Term Partnerships',
      description: 'You refer once. We serve the customer for years. Everyone wins.'
    }
  ];

  return (
    <section id="commission-value" className="py-20 bg-gradient-to-br from-hector-blue via-hector-purple to-hector-pink text-white relative overflow-hidden">
            {/* === FLOATING LINES BACKGROUND === */}
      <div className="absolute inset-0 z-0 opacity-40 pointer-events-none">
        <FloatingLines 
          enabledWaves={['top', 'middle', 'bottom']}
          lineCount={[10, 15, 20]}
          lineDistance={[8, 6, 4]}
          bendRadius={5.0}
          bendStrength={-0.5}
          interactive={true}
          parallax={true}
        />
      </div>

      {/* === GLOW ELEMENTS === */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full filter blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-5xl mx-auto mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            We're Not Competing on Price. <br/>We're Competing on Results.
          </h2>
          <p className="text-xl leading-relaxed opacity-90">
            Other affiliate programs offer 20-30% because they're trying to own the customer relationship. We're not.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {values.map((value, index) => (
            <div key={index} className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className={`fas ${value.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-3">{value.title}</h3>
              <p className="opacity-90 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Stats Banner */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 mt-12 max-w-4xl mx-auto border border-white/20">
          <div className="grid md:grid-cols-2 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">$200M</div>
              <div className="text-lg opacity-90">Ad Spend Managed Annually</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">94%</div>
              <div className="text-lg opacity-90">Customer Retention Rate</div>
            </div>
          </div>
        </div>
        
        {/* CTA */}
        <div className="text-center mt-12 space-y-4">
     <a 
  href="https://hector.partnerstack.com/" 
  target="_blank" 
  rel="noopener noreferrer"
  className="inline-block"
>
  <button
    className="cta-button px-8 py-4 rounded-xl font-semibold text-white text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 w-auto inline-block"
    style={{
      background: "linear-gradient(90deg, #CC2EF4 0%, #3E2EF4 100%)",
    }}
  >
    SEE HOW TO EARN $32K+/YEAR
  </button>
</a>

          <p className="text-sm opacity-90">
            Join active earners making 4-5 figures monthly.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CommissionValue;
